import * as Guards from './progress-by-device.model.type.guard'
import { ProgressDto } from './progress.model'
import moment from 'moment'

/** @see {isProgressByDeviceDto} ts-auto-guard:type-guard */
export interface ProgressByDeviceDto {
  lengthProgress: Record<string, ProgressDto[]>
  countProgress: Record<string, ProgressDto[]>
}

export function progressByDeviceDateParsed(
  progress: Record<string, ProgressDto[]>,
): Record<string, ProgressDto[]> {
  Object.entries(progress).forEach(
    entry =>
      (progress[entry[0]] = entry[1].map(
        (progress: ProgressDto): ProgressDto => ({
          ...progress,
          date: moment(progress.date, 'YYYY-MM-DD'),
        }),
      )),
  )
  return progress
}

export { Guards }
